export var ReceiptItemType;
(function (ReceiptItemType) {
    ReceiptItemType[ReceiptItemType["PURCHASE"] = 1] = "PURCHASE";
    ReceiptItemType[ReceiptItemType["RETURN"] = 2] = "RETURN";
    ReceiptItemType[ReceiptItemType["TRANSFER"] = 3] = "TRANSFER";
})(ReceiptItemType || (ReceiptItemType = {}));
//# sourceMappingURL=receipt-item-type.js.map